import { render, staticRenderFns } from "./RuleColumnsPanel.vue?vue&type=template&id=69bb635d"
import script from "./RuleColumnsPanel.vue?vue&type=script&lang=js"
export * from "./RuleColumnsPanel.vue?vue&type=script&lang=js"
import style0 from "./RuleColumnsPanel.vue?vue&type=style&index=0&id=69bb635d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports